import React, { HTMLAttributes } from 'react';
import classnames from 'classnames';
import styles from './action-box.module.scss';

export function ActionBox({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
	return <div className={classnames(styles.actionBox, className)} {...rest} />;
}

export function Action({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
	return <span className={classnames(styles.action, className)} {...rest} />;
}
